import React from 'react';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';

import { routeTree } from './routeTree.gen';

const router = createRouter({
  routeTree,
  context: {
    queryClient: undefined!,
  },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const Router: React.FC = () => {
  const queryClient = useQueryClient();

  return <RouterProvider router={router} context={{ queryClient }} />;
};

export default Router;
